import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { GuidePage } from '@model';

@Component({
  selector: 'app-guide-viewer',
  standalone: false,
  templateUrl: './guide-viewer.component.html'
})
export class GuideViewerComponent implements OnInit {
  @Input()
  pages: GuidePage[] = [];

  pageNumber: number = 0;

  @Output()
  cancel: EventEmitter<void> = new EventEmitter<void>();

  ngOnInit(): void {
    
  }

  onCancel(){
    this.cancel.emit();
  }

  onNextPage() {
    if (this.pageNumber < this.pages.length - 1) {
      this.pageNumber = this.pageNumber + 1;
    }
  }

  onPreviousPage() {
    if (0 < this.pageNumber) {
      this.pageNumber = this.pageNumber - 1;
    }
  }

  pageChange(event: any) {
    this.pageNumber = event.selectedIndex;
  }
}
